import {_addToEventLog, forceAppUpdate} from '../app/app'
import Config from '../launch/config'
import Effects from '../effects/effects'
import ArcTimer from '../arc-timer/arc-timer'
import {saveGame} from '../launch/store'
import {gameOverCheck} from '../game-over/utils'
import {isDebug} from '../launch/utils'
import audio from '../launch/audio'

const handleColonizeClick = (entity) => {
    if (!entity) {
        return
    }

    const {x, y} = entity
    const difficulty = Config.difficultyLevels[Config.difficulty]
    const conquering = entity.faction === Config.enemyFactionName

    entity.isColonizing = true
    forceAppUpdate()

    const arc = new ArcTimer({
        color: Config.colorGreen,
        duration: difficulty.planetColonizeTime,
        radius: entity.diameter + 2,
        reverse: true,
        x,
        y,
    })

    entity.statusLabel.setText(conquering ? 'Conquering' : 'Colonizing')

    arc.promise.then(() => {
        entity.statusLabel.setText('')
        Config.gameStats.resources += difficulty.planetResourceBonus

        if (conquering) {
            Config.gameStats.planetsConquered += 1
            Config.gameStats.score += difficulty.planetConquerPoints
            new Effects().scoreAnim({
                x,
                y,
                num: difficulty.planetConquerPoints,
                positive: true,
            })
        } else {
            Config.gameStats.planetsColonized += 1
            Config.gameStats.score += difficulty.planetColonizePoints
            new Effects().scoreAnim({
                x,
                y,
                num: difficulty.planetColonizePoints,
                positive: true,
            })
        }

        // Since we're showing two scores, delay the second animation
        setTimeout(() => {
            new Effects().resourceAnim({
                x,
                y,
                num: difficulty.planetResourceBonus,
                positive: true,
            })
        }, Config.pointAnimDelay)

        let faction = Config.userFactionName

        if (isDebug) {
            if (entity.faction === Config.userFactionName) {
                faction = Config.enemyFactionName
            } else {
                faction = Config.userFactionName
            }
        }

        entity.faction = faction
        entity.colonized = true
        entity.isColonizing = false

        _addToEventLog({
            html: `The planet <span style="color: #${Config.colorGreen}">${
                entity.name
            }</span> has been ${conquering ? 'conquered' : 'colonized'}`,
            coords: {x, y},
        })
        audio.colonize()
        saveGame(`${entity.name} colonize`)
        gameOverCheck(`${entity.name} colonize`)

        // TODO: Why is this delay required to set collected artifacts?
        setTimeout(() => {
            forceAppUpdate()
        }, 100)
    })
}

export default handleColonizeClick
